<template>
  <div class="py-4 container-fluid">
    <div class="row">

      <div class="col-4" v-for="dia in state.dias" :key="dia.id">
        <div class="card">
          <div class="d-flex justify-content-between">
            <h4 class="m-0">{{ dia.nome }}</h4>
          </div>
          <hr />
          <div class="d-flex flex-column gap-2">
            <table class="">
              <thead>
                <th>Marketplace</th>
                <th>Horário</th>
              </thead>
              <tbody>
                <tr v-for="marketplace in state.marketplaces" :key="marketplace.id">
                  <td style="text-align: left;">{{ marketplace.nome }}</td>
                  <td style="text-align: left;">
                    <div>
                      <div>
                        {{ getHorarioPorMarketplaceDia(marketplace.sigla, dia.id)?.hora || "Não encontrado" }}
                        <button class="btn-transparent"
                          @click="openModalHorario(getHorarioPorMarketplaceDia(marketplace.sigla, dia.id)?.id, dia.id, marketplace.sigla)">
                          <i class="bi bi-pencil"></i>
                        </button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>
        </div>
      </div>
    </div>

    <ModalHorario v-if="modalHorarioVisible" :horario="horarioForm" @close="closeModalHorario" @salvar="salvar">
      <template #footer>
        <button type="button" class="btn btn-secondary" @click="closeModalHorario">
          Fechar
        </button>
      </template>
    </ModalHorario>

  </div>
</template>

<script>
import { onMounted, reactive, ref, watch, computed } from "vue";
import services from "../../services";

import { useStorage } from "vue3-storage";
import ModalHorario from "../Modal/ModalHorario.vue";

export default {
  components: { ModalHorario },
  setup() {
    const storage = useStorage();
    const token = storage.getStorageSync("token");
    const id = storage.getStorageSync("id");
    const colaboradorData = reactive({});
    const checkedTarefas = reactive({});

    // Reactive separado para o formulário de horário
    const horarioForm = reactive({
      hora: ''
    });

    //state.horarios.find(h => h.id === horario_id);

    const state = reactive({
      colaboradores: [],
      horarios: [],
      horario: {},
      dias: [
        {
          id: 1,
          nome: "Segunda",
        },
        {
          id: 2,
          nome: "Terça"
        },
        {
          id: 3,
          nome: "Quarta"
        },
        {
          id: 4,
          nome: "Quinta"
        },
        {
          id: 5,
          nome: "Sexta"
        },
      ],
      marketplaces: [
        {
          id: 1,
          sigla: "mercado_livre",
          nome: "Mercado Livre"
        },
        {
          id: 2,
          sigla: "shopee",
          nome: "Shopee",
        },
        {
          id: 3,
          sigla: "shein",
          nome: "Shein"
        },
        {
          id: 4,
          sigla: "site",
          nome: "Site"
        }
      ]
    });

    // Computed para buscar horário baseado em marketplace e dia
    const getHorarioPorMarketplaceDia = computed(() => {
      return (marketplace, dia) => {
        return state.horarios.find(h => h.marketplace == marketplace && h.dia == dia);
      };
    });

    const modalVisible = ref(false);

    const colaboradorIdForNewTask = ref(null);

    onMounted(() => {
      fetchHorarios();
    });



    async function fetchHorarios() {
      try {
        const { data } = await services.horarios.getAll({ token });
        state.horarios = data;
      } catch (err) {
        console.error(err);
      }
    }


    const selectedTarefa = ref(null);
    const modalHorarioVisible = ref(false);
    const modalHorarioInfosVisible = ref(false);

    function openModalHorario(horario_id, dia, marketplace) {
      state.horario = state.horarios.find(h => h.id == horario_id) || {};

      if (Object.keys(state.horario).length === 0) {
        state.horario.dia = dia;
        state.horario.marketplace = marketplace;
      }
      // Limpar o formulário primeiro
      horarioForm.hora = '';

      // Atribuir valores apenas se existirem
      if (state.horario && state.horario.hora) {
        horarioForm.hora = state.horario.hora;
      }
      modalHorarioVisible.value = true;
    }

    function closeModalHorario() {
      modalHorarioVisible.value = false;
    }

    async function salvar(tarefa) {
      try {
        // Atualizar Horário
        const horario = tarefa.horario;
        let data;

        if (state.horario.id) {
          const response = await services.horarios.update({
            id: state.horario.id,
            dia: state.horario.dia,
            marketplace: state.horario.marketplace,
            hora: horario,
            token
          });
          data = response.data;
        } else {
          const response = await services.horarios.save({
            dia: state.horario.dia,
            marketplace: state.horario.marketplace,
            hora: horario,
            token
          });
          data = response.data;
        }

        // Verificar se o horário foi salvo com sucesso (resposta contém um objeto com id)
        if (data && typeof data === 'object' && data.id) {
          // Recarregar todos os horários para evitar race conditions
          await fetchHorarios();
        }

        // Fechar o modal apenas uma vez, no final
        closeModalHorario();
      } catch (error) {
        console.error("Erro ao salvar horário:", error);

        // Verificação específica para erro 422 do Laravel (Validation Error)
        if (error.response && error.response.status === 422) {
          const validationErrors = error.response.data.errors || error.response.data.message;

          if (typeof validationErrors === 'object') {
            // Se são erros de validação específicos por campo
            const errorMessages = Object.values(validationErrors).flat().join('\n');
            alert(`Erro de validação:\n${errorMessages}`);
          } else {
            // Se é uma mensagem geral
            alert(`Erro de validação: ${validationErrors}`);
          }
        } else if (error.response && error.response.data && error.response.data.message) {
          // Outros erros do servidor
          alert(`Erro: ${error.response.data.message}`);
        } else {
          // Erro genérico
          alert('Erro ao salvar horário. Tente novamente.');
        }

        // Ainda fechar o modal mesmo em caso de erro
        closeModalHorario();
      }
    }


    return {
      state,
      colaboradorData,
      colaboradorIdForNewTask,
      modalHorarioVisible,
      modalHorarioInfosVisible,
      selectedTarefa,
      horarioForm,
      getHorarioPorMarketplaceDia,
      openModalHorario,
      closeModalHorario,
      salvar,
      checkedTarefas,
    };
  },
};
</script>
<style scoped>
h5 {
  color: #202020;
}

tr {
  text-align: center;
}

th {
  border-bottom: solid 2px #202020 !important;
}

td {
  border-bottom: solid 1px #202020 !important;
  color: #202020;
}

.card {
  border: solid 2px #56008f;
  border-radius: 10px;
  background-color: #fff;
  padding: 1rem;
  margin-bottom: 1rem;
}

.card-tarefa:hover {
  transform: scale(0.);
}

.btn {
  transform: none !important;
  margin-right: 5px;
  margin-bottom: 0;
  padding: 10px;
  width: 40px;
}

#btn_new_user {
  color: #202020;
  font-weight: 600;
  padding: 5px;
  border: solid 2px #202020;
  border-radius: 5px;
  background-color: rgb(152, 152, 152);
  transition: 0.2s;
}

#btn_new_user:hover {
  background-color: rgb(210, 209, 209);
}

.table-hover>tbody>tr:hover>* {
  color: #202020;
  background-color: rgb(225, 225, 225);
}

.add-tarefa {
  border: none;
  color: white;
  background-color: #56008f;
  aspect-ratio: 1 / 1;
  max-height: fit-content;
}

.tarefa {
  border: 1px solid #56008f;
  background-color: #f8eeff;
  transition: 0.15s ease-in-out;
}

.tarefa:hover {
  transform: scale(0.975);
}

.tarefa div {
  text-align: left;
}

.action_buttons button {
  border: none;
  transition: 0.15s ease-in-out;
}

.action_buttons label {
  font-size: 1.25rem;
  margin: 0;
}

.action_buttons i {
  color: #808080;
  width: 100%;
}

.checked-icon {
  color: #3dd03d !important;
}

.btn-danger {
  margin: 0;
  padding: 5px;
  max-height: fit-content;
}

.btn-danger i {
  color: white;
  width: fit-content;
}

.btn-transparent {
  background-color: transparent;
  border: none;
}
</style>
